module.exports = "<div class=\"file-upload-multiple\">\n    <file-upload-input\n      v-for=\"file in files\"\n      :accept=\"accept\"\n      :key=\"file.key\"\n      :translateStrings=\"translateStrings\"\n      v-on:file-changed=\"onFileChanged( file )\"\n      v-on:file-removed=\"onFileRemoved( file )\"\n    >\n    </file-upload-input>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/file-upload-multiple/file-upload-multiple.vhtml
// module id = 304
// module chunks = 0